/* eslint-disable indent*/
const DisabilityCoverageAmountValues = Object.freeze([
    500,
    1_000,
    2_000,
    3_000,
    4_000,
    5_000,
    7_500,
    10_000,
    15_000,
    'over-15000',
]);

// 15_000
export const DisabilityCoverageAmountHighestValue = DisabilityCoverageAmountValues[DisabilityCoverageAmountValues.length - 2];

// 'over-15000'
export const DisabilityCoverageAmountSurplusValue = DisabilityCoverageAmountValues[DisabilityCoverageAmountValues.length - 1];

export default DisabilityCoverageAmountValues;
